import NotificationsList from 'components/NotificationsList';

const Notifications = () => {
  return (
    <NotificationsList />
  );
};

export default Notifications;
